export const isRequired = (errorText: string) => {
  return (value: unknown) => {
    if (typeof value === 'string') {
      return value.trim().length > 0 || errorText;
    }
    if (typeof value === 'boolean') {
      return value || errorText;
    }
    if (typeof value === 'number') {
      return !Number.isNaN(value) || errorText;
    }
    if (Array.isArray(value)) {
      return value.length > 0 || errorText;
    }
    if (value && typeof value === 'object') {
      return true;
    }
    return !!value || errorText;
  };
};
